import {useGlobalFulfillmentDetail} from '@/components/global/providers/GlobalFulfillmentDetailProvider';
import {useEventBarV2} from '../EventBarV2Provider';
import {
  EMPTY_FULFILLMENT_BASELINE,
  getMenuFulfillmentPending,
  type MenuFulfillmentPending,
} from '../utils/fulfillment';

// The staged-vs-persisted diff for the menu-page editing flow, shared by the catch-all trigger
// (EventBarV2's click-away) and the modal's summary so both read the same source. With no persisted
// detail (landed on the menu directly, with no cart) the staged fields are diffed against an empty
// baseline — the commit creates the detail in that case, so leaving the bar still has something to
// confirm.
export const useMenuFulfillmentPending = (): MenuFulfillmentPending => {
  const {fulfillmentDetail} = useGlobalFulfillmentDetail();
  const {whereSelection, fulfillmentType, whenDate, whenTime, headCount, eventName} =
    useEventBarV2();

  return getMenuFulfillmentPending({
    whereSelection,
    // A resolved selection only exists after the user edits Where, and the commit builder already
    // gates the address on `whereSelection`, so this stands in for the edited-Where ref without
    // reading a ref during render.
    hasUserEditedWhere: whereSelection !== null,
    fulfillmentType,
    whenDate,
    whenTime,
    headCount,
    eventName,
    fulfillmentDetail: fulfillmentDetail ?? EMPTY_FULFILLMENT_BASELINE,
  });
};
